import { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, List, ListItem, ListItemText, Typography } from '@mui/material'

import { ModalWrapper } from '../modal-wrapper'
import { IItemDetails, IItemRelation } from 'src/types'

import { useStyles } from './styles'

interface IItemsRemoveConfirmModal {
  open: boolean
  handleClose: () => void
  itemsTitles?: string[]
  itemsRelations?: IItemRelation[]
  itemsDetails?: IItemDetails[]
  itemsType?: string
  handleConfirm?: () => void | Promise<void>
}

const ItemsRemoveConfirmModal = ({
  open,
  handleClose,
  itemsTitles,
  itemsRelations,
  itemsDetails = [],
  itemsType,
  handleConfirm,
}: IItemsRemoveConfirmModal) => {
  const [t] = useTranslation()
  const classes = useStyles()

  if (!itemsTitles || !handleConfirm || !itemsRelations || !itemsType) return null

  const handleConfirmClick = async () => {
    await handleConfirm()
    handleClose()
  }

  return (
    <ModalWrapper open={open} onClose={handleClose} className={classes.modalWrapper}>
      <div>
        <Typography className={classes.title}>{t('confirm-delete-title.v')}</Typography>
        <Typography>
          {t('confirm-delete-warning.v')}&nbsp;{itemsType}&nbsp;
          <b className={classes.itemTitle}>{itemsTitles.join(', ')}</b>
          {itemsRelations.length > 0 && ' ' + t('confirm-delete-warning-1.v')}?
        </Typography>
        <List dense>
          {itemsRelations.map(({ title, relations }) => (
            <ListItem key={title} sx={{ display: 'block' }} disableGutters>
              <ListItemText
                primaryTypographyProps={{ className: classes.itemTitle }}
                primary={`${title}:`}
              />
              <Typography className={classes.relationsTitle}>
                {relations.map((name) => (
                  <Fragment key={name}>
                    {name} <br />
                  </Fragment>
                ))}
              </Typography>
            </ListItem>
          ))}
        </List>
        {itemsDetails.length > 0 && (
          <List dense>
            {itemsDetails.map(({ title, text }) => (
              <ListItem key={title} sx={{ display: 'block' }} disableGutters>
                <ListItemText
                  primaryTypographyProps={{ className: classes.itemTitle }}
                  primary={`${title}:`}
                />
                <Typography className={classes.relationsTitle}>{text}</Typography>
              </ListItem>
            ))}
          </List>
        )}
      </div>
      <div className={classes.buttonsWrapper}>
        <div className={classes.buttonWrapper}>
          <Button fullWidth variant="outlined" onClick={handleClose}>
            {t('cancel-button-text.v')}
          </Button>
        </div>
        <div className={classes.buttonWrapper}>
          <Button fullWidth variant="contained" onClick={handleConfirmClick}>
            {t('delete-button-text.v')}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  )
}

export { ItemsRemoveConfirmModal }
